export const feedProductIncludes: string =
	'' +
	'audits,' +
	'audits.user,' +
	'faults,' +
	'faults.owner,' +
	'feedtanks,' +
	'feedtanks.audits,' +
	'feedtanks.audits.user,' +
	'feedtanks.entitylocation,' +
	'feedtanks.feedtype,' +
	'feedtanks.formula,' +
	'feedtanks.sensor,' +
	'feedtanks.sensor.node.transceiver.site,' +
	'feedtanks.sensor.transceiver.site,' +
	'feedtanks.transceiver.site,' +
	'org,' +
	'site,' +
	'site.address,' +
	'subscriptionitem,' +
	'subscriptionitem.audits,' +
	'subscriptionitem.audits.user,' +
	'users,' +
	'discount';
